export default __webpack_public_path__ + "static/media/E12.b2b03509.jpeg";